import "./Bio.css";

const BioNarrative = () => {
  return (
    <div className="bio-paragraph">
      <p>{`Réalisatrice au parcours transatlantique (MFA) avec une expérience de production en France (Danone, La Halle, Orange), je navigue entre fiction, documentaire et brand content.`}</p>
      <p>
        {`Du sujet de société au rituel quotidien lifestyle, je transforme chaque script en un récit humain et immersif. `}
        {`Collaboratrice de confiance, engagée auprès des équipes techniques comme des marques.`}
      </p>
    </div>
  );
};

const BioCommercial = () => {
  return (
    <div className="bio-paragraph">
      <p>
        {`Hello ! Bienvenue.`} <br />
        {` De la fiction à la publicité (Danone, La Halle, Orange), je capture la beauté des connexions humaines à travers des visuels Lifestyle au service de vos marques.`}
      </p>
      <p>
        {`Ma force ? Créer un storytelling immersif où le produit embellit le quotidien et l'image suscite la joie. `}
        {`Disponible pour vos prochains projets publicitaires. `}
        {`Contactez-moi par téléphone ou par mail.`}
      </p>
    </div>
  );
};

const BioHeadshot = () => {
  return (
    <div className="bio-headshot">
      <img
        src={require("../assets/images/elya-headshot.jpg")}
        alt="Elya Randrianaivo"
        className="bio-headshot__image"
      />
    </div>
  );
};

export { BioCommercial, BioHeadshot, BioNarrative };
